<div [class.fullscreen]="fullScreenLeftBox">
    <div class="action-hierarchy-summary" [id]="componentId">
        <div class="action-hierarchy-summary-top-panel">
            <div class="action-hierarchy-summary-header">
                <div class="ltms-widget-title">
                    {{ title }}
                </div>
                <div class="action-hierarchy-summary-tools">
                    <div class="filter-text">View by</div>

                    <!-- <app-ltms-dropdown [config]="dropdown" [elementid]="dropdown.elementid"
                        (onChange)="onFilterChange($event)"></app-ltms-dropdown> -->
                    <app-score-dropdown-menu [config]="viewTypeDropdown.config"
                        [selectedOption]="viewTypeDropdown['selectedOption']" [options]="viewTypeDropdown.options"
                        (selectedOptionChange)="onFilterChange($event)"></app-score-dropdown-menu>
                    <div class="action-widget-container">
                        <!-- <app-ltms-widget-tools [config]='widgetConfig' [elementId]="widgetConfig.elementId"
                    (onViewChange)="onViewChange($event)"></app-ltms-widget-tools> -->
                        <app-score-widget [config]="scoreWidget('drilldown')" (onDownloadClick)="onDownload()"
                            (onFullscreenClick)="onFullscreenLeftBox($event, 'drillDownTable')"></app-score-widget>
                    </div>
                </div>
            </div>
            <div class="action-hierarchy-summary-top-panel-discription ltms-description">
                {{ discription }}
            </div>
        </div>
        <div *ngIf="isDataAvailable && isDataLoaded == true">
            <div class="action-hierarchy-table-container" [id]="containerId">
                <div class="action-hierarchy-summary-drilldown">
                    <!-- <app-ltms-drilldown-table [data]="overallTable" [tableId]="overAllTableId"
                    [staticId]="overallStaticId"></app-ltms-drilldown-table> -->
                    <app-score-table [tableColumns]="distributionTable.tableHeader" (onTextClickCall)="resetHierarchData()"
                        [tableData]="distributionTable.tableRow"></app-score-table>
                </div>
                <div class="action-hierarchy-summary-drilldown">
                    <!-- <app-ltms-drilldown-table [data]="drilldownTable" [tableId]="childTableId" [staticId]="childStaticId"
                    (onHirarchyChange)="onDrillDown($event)"></app-ltms-drilldown-table> -->
                    <app-score-table [tableColumns]="comapreWithTable.tableHeader"
                        (onDrillDownClick)="onDrillDown($event, 'drilldown')" (onTextClickCall)="onDrillDown($event, 'selectRow')"
                        [tableData]="comapreWithTable.tableRow"></app-score-table>
                </div>
            </div>
        </div>
        <div *ngIf="!isDataAvailable && isDataLoaded == true">
            <app-ltms-error [code]="errorCode"></app-ltms-error>
        </div>
        <div class="data-details-loader" *ngIf="isDataLoaded == false">
            <app-ltms-loader></app-ltms-loader>
        </div>
    </div>
</div>